"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtkEnrollmentService = void 0;
var rest_service_1 = require("./rest.service");
var enums_1 = require("../shared/enums");
var date_fns_1 = require("date-fns");
var auth_service_1 = require("./auth.service");
/**
 * Class declaration
 */
var OtkEnrollmentService = /** @class */ (function (_super) {
    __extends(OtkEnrollmentService, _super);
    /**
     * constructor
     */
    function OtkEnrollmentService(configService) {
        var _this = this;
        var authServiceInstance = new auth_service_1.AuthService();
        _this = _super.call(this, {
            serviceName: enums_1.ServicesEnum.ENROLLMENT,
            baseURL: configService.config.enrollmentServiceUrl,
            authService: authServiceInstance,
        }) || this;
        _this.schoolsGradingSummaryPath = '/schools/:schoolId/grade-summary';
        _this.schoolSchedulePath = '/schools/:schoolId/schedule';
        _this.schoolsStudentCourseSchedulePath = '/schools/:schoolId/students/:studentId/courses/:courseId/schedule';
        _this.assignmentSummaryPath = '/schools/:schoolId/average-assignments';
        _this.eventsPath = '/events';
        _this.authService = authServiceInstance;
        return _this;
    }
    /**
     * getGradingSummaryBySchool
     * @param schoolUUID school UUID to use
     * @param includeAssignments true to load assignments
     * @returns the StudentSummary
     */
    OtkEnrollmentService.prototype.getGradingSummaryBySchool = function (schoolUUID, includeAssignments) {
        return __awaiter(this, void 0, void 0, function () {
            var schoolId, response, rejectReason_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        schoolId = schoolUUID || this.authService.schoolId || '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request(this.schoolsGradingSummaryPath.replace(':schoolId', schoolId), enums_1.RequestMethodEnum.GET, null, includeAssignments && { includeAssignments: includeAssignments })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_1 = _a.sent();
                        throw new Error("Unable get grading summary for ".concat(schoolUUID, " -> ") + rejectReason_1);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Lists students and their schedule
     * @param startDate date
     * @param endDate date
     * @param schoolUUID school UUID to use, optional, default get from auth service
     * @returns Lists students and their schedule
     */
    OtkEnrollmentService.prototype.getSchoolSchedule = function (startDate, endDate, schoolUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var schoolId, url, isoStartDate, isoEndDate, response, rejectReason_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        schoolId = schoolUUID || this.authService.schoolId || '';
                        url = this.schoolSchedulePath.replace(':schoolId', schoolId);
                        isoStartDate = (0, date_fns_1.formatISO)(startDate, { representation: 'date' });
                        isoEndDate = (0, date_fns_1.formatISO)(endDate, { representation: 'date' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request(url, enums_1.RequestMethodEnum.GET, null, {
                                startDate: isoStartDate,
                                endDate: isoEndDate,
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_2 = _a.sent();
                        throw new Error("Unable to get school schedule for [".concat(isoStartDate, ", ").concat(isoEndDate, ", ").concat(schoolId, "] -> ") +
                            rejectReason_2);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns Course Schedule data for the provided student and course
     * @param studentUUID student UUID to use
     * @param courseUUID course UUID to use
     * @param schoolUUID school UUID to use, optional, default get from auth service
     * @returns Returns Course Schedule data
     */
    OtkEnrollmentService.prototype.getCourseScheduleData = function (studentUUID, courseUUID, schoolUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var schoolId, url, response, rejectReason_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        schoolId = schoolUUID || this.authService.schoolId || '';
                        url = this.schoolsStudentCourseSchedulePath
                            .replace(':schoolId', schoolId)
                            .replace(':studentId', studentUUID)
                            .replace(':courseId', courseUUID);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request(url, enums_1.RequestMethodEnum.GET)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_3 = _a.sent();
                        throw new Error("Unable to retrieve course schedule data for [".concat(schoolId, ", ").concat(studentUUID, ", ").concat(courseUUID, "] -> ") +
                            rejectReason_3);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the indicated schedule
     * @param studentUUID
     * @param courseUUID
     * @param schedule
     * @param schoolUUID
     * @returns Receives the new schedule and returns the updated schedule
     */
    OtkEnrollmentService.prototype.updateCourseScheduleData = function (studentUUID, courseUUID, schedule, schoolUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var schoolId, url, rejectReason_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        schoolId = schoolUUID || this.authService.schoolId || '';
                        url = this.schoolsStudentCourseSchedulePath
                            .replace(':schoolId', schoolId)
                            .replace(':studentId', studentUUID)
                            .replace(':courseId', courseUUID);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request(url, enums_1.RequestMethodEnum.PUT, schedule, null, true, {
                                Accept: '*/*',
                                'Content-Type': 'application/json',
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        rejectReason_4 = _a.sent();
                        throw new Error("Unable to update course schedule data for [".concat(schoolId, ", ").concat(studentUUID, ", ").concat(courseUUID, "] -> ") +
                            rejectReason_4);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns average number of assignments per school day.
     * @param courseUUID required course id
     * @param startDate required date
     * @param endDate required date
     * @param schoolUUID school UUID to use, optional, default get from auth service
     * @returns average number of assignments per school day
     */
    OtkEnrollmentService.prototype.getAssignmentSummaryData = function (courseUUID, startDate, endDate, schoolUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var schoolId, url, response, rejectReason_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        schoolId = schoolUUID || this.authService.schoolId || '';
                        url = this.assignmentSummaryPath.replace(':schoolId', schoolId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request(url, enums_1.RequestMethodEnum.GET, null, {
                                courseId: courseUUID,
                                startDate: (0, date_fns_1.format)(startDate, 'yyyy-MM-dd'),
                                endDate: (0, date_fns_1.format)(endDate, 'yyyy-MM-dd'),
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_5 = _a.sent();
                        throw new Error("Unable to get average assignment summary for [".concat(schoolId, ", ").concat(courseUUID, "] -> ") +
                            rejectReason_5);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns a new event with ID from API.
     * @param event OtkEvent Object
     * @returns Returns a new event from API.
     */
    OtkEnrollmentService.prototype.createNewEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.update(this.eventsPath, event)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_6 = _a.sent();
                        throw new Error("Unable to create event for [".concat(event.eventId, "] -> ") + rejectReason_6);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns an Updated event from API.
     * @param event OtkEvent Object
     * @returns Returns an Updated event from API.
     */
    OtkEnrollmentService.prototype.updateEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.update(this.eventsPath, event, event.eventId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_7 = _a.sent();
                        throw new Error("Unable to update event for [".concat(event.eventId, "] -> ") + rejectReason_7);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns 204 if deleted.
     * @param eventUUID OtkEvent UUID
     * @returns Returns HTTP 204 code if event is successful deleted from API.
     */
    OtkEnrollmentService.prototype.deleteEvent = function (eventUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.delete(this.eventsPath, eventUUID)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_8 = _a.sent();
                        throw new Error("Unable to delete event for [".concat(eventUUID, "] -> ") + rejectReason_8);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return OtkEnrollmentService;
}(rest_service_1.RestService));
exports.OtkEnrollmentService = OtkEnrollmentService;
